var map = {
	"./ad.svg": "4c62",
	"./al.svg": "0e27",
	"./am.svg": "1071",
	"./at.svg": "4919",
	"./ba.svg": "17d3",
	"./be.svg": "6f74",
	"./bg.svg": "4d42",
	"./by.svg": "81cd",
	"./ca.svg": "5635",
	"./ch.svg": "b6af",
	"./cn.svg": "8f59",
	"./cy.svg": "ebcc",
	"./cz.svg": "d103",
	"./de.svg": "eca6",
	"./dk.svg": "587e",
	"./ee.svg": "7d3a",
	"./es.svg": "9a2f",
	"./fi.svg": "a7b7",
	"./fr.svg": "8f00",
	"./gb.svg": "ea15",
	"./gi.svg": "b951",
	"./gr.svg": "3732",
	"./hr.svg": "99ad",
	"./hu.svg": "f244",
	"./ie.svg": "a1e1",
	"./is.svg": "aaa5",
	"./it.svg": "a248",
	"./jp.svg": "6c59",
	"./li.svg": "43e8",
	"./lt.svg": "fb88",
	"./lu.svg": "daf7",
	"./lv.svg": "0f98",
	"./ma.svg": "6362",
	"./mc.svg": "444d",
	"./mk.svg": "9764",
	"./mt.svg": "b7f7",
	"./nl.svg": "7cbb",
	"./no.svg": "13ac",
	"./pl.svg": "4240",
	"./pt.svg": "9072",
	"./ro.svg": "8103",
	"./ru.svg": "a0fd",
	"./se.svg": "6018",
	"./si.svg": "9079",
	"./sk.svg": "9871",
	"./sm.svg": "7825",
	"./ua.svg": "e18a",
	"./us.svg": "b38c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e83";